/**
 * DevExtreme (esm/ui/list/modules/search.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import searchBoxMixin from "../../widget/ui.search_box_mixin";
import TextBox from "../../text_box";
searchBoxMixin.setEditorClass(TextBox);
